import { AwsRum } from 'aws-rum-web';
import { AWS_RUM_ID, AWS_RUM_REGION, VERSION, AWS_IDENTITY_POOL_ID, } from '../constants/env';
const ABSENCE_VALUE = '__UNSET__';
export default class AwsRumFactory {
    static createInstance() {
        if (!AWS_RUM_ID) {
            return this.basicRum();
        }
        const config = {
            sessionSampleRate: 1,
            endpoint: `https://dataplane.rum.${AWS_RUM_REGION}.amazonaws.com`,
            telemetries: [
                "errors",
                "performance",
                [
                    'http',
                    {
                        recordAllRequests: true,
                        addXRayTraceIdHeader: true,
                    },
                ],
            ],
            allowCookies: true,
            enableXRay: false,
            disableAutoPageView: true,
        };
        const poolIdDefined = AWS_IDENTITY_POOL_ID && AWS_IDENTITY_POOL_ID !== ABSENCE_VALUE;
        if (!poolIdDefined) {
            console.error('RUM Error: Identity pool is not defined. Cannot initialize RUM.');
            return this.basicRum();
        }
        if (poolIdDefined) {
            const configUnauth = {
                ...config,
                identityPoolId: AWS_IDENTITY_POOL_ID,
            };
            try {
                return new AwsRum(AWS_RUM_ID, VERSION, AWS_RUM_REGION, configUnauth);
            }
            catch (error) {
                console.error("RUM ERROR using Identity pool:", error);
            }
            return this.basicRum();
        }
        return this.basicRum();
    }
    static basicRum() {
        return {
            recordPageView: () => null,
            recordError: () => null,
        };
    }
}
